import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/ServiceDetails.css";
import WhatsAppFloat from "../components/WhatsAppFloat"


function Study() {
  return (
    <div>
      <Navbar />

      <section className="service-detail">

        <h1>University Admission / Study Visa Services</h1>

        <p className="intro">
          Our agency provides <b>comprehensive University Admission and Study Visa assistance</b> for students who wish to pursue higher education abroad.
          We guide you from <i>application to visa approval and arrival</i> at your chosen institution.
        </p>

        <img
          src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&auto=format&fit=crop&q=60"
          alt="Students studying abroad"
          className="service-image"
        />

        <div className="content">

          
          <h2>What is a Study Visa?</h2>

          <p>
            A <b>Study Visa (Student Visa)</b> is an official authorization that allows international students
            to live and study in a foreign country for the duration of their academic program.
          </p>

          <p>
            It is tied to admission into recognized institutions such as universities, colleges, or vocational schools.
            <i> Each country has different requirements, and we help you meet all of them correctly.</i>
          </p>

          
          <h2>Our Study Visa and Admission Services Include</h2>

          <h3>1. Academic Counseling and Guidance</h3>
          <p>
            We help you choose the right course and institution based on your academic background,
            career goals, budget, and preferred country.
          </p>

          <h3>2. University and College Application Support</h3>
          <p>We assist in ensuring:</p>
          <ul>
            <li>Properly filled applications</li>
            <li>On-time submissions</li>
            <li>Correct document uploads</li>
            <li>Full compliance with admission requirements</li>
          </ul>

          <h3>3. Course and Institution Selection</h3>
          <p>
            We guide you in selecting <b>accredited institutions</b> that align with your career goals and future opportunities.
          </p>

          <h3>4. Document Preparation and Review</h3>
          <p>We help you prepare and verify:</p>

          <ul>
            <li>Academic transcripts and certificates</li>
            <li>International passport</li>
            <li>Statement of Purpose (SOP)</li>
            <li>Letters of Recommendation (LOR)</li>
            <li>Curriculum Vitae (CV)</li>
            <li>Proof of funds or sponsorship documents</li>
            <li>IELTS / TOEFL results (if required)</li>
          </ul>

          <h3>5. Statement of Purpose (SOP) Assistance</h3>
          <p>
            We help you write a <b>professional and compelling SOP</b> that highlights your academic goals and motivation.
          </p>

          <h3>6. Admission Processing and Offer Letter Assistance</h3>
          <p>
            We assist in securing your official <b>admission offer letter</b>, which is required for your student visa.
          </p>

          <h3>7. Visa Application Support</h3>
          <p>We guide you through:</p>

          <ul>
            <li>Visa application form completion</li>
            <li>Embassy appointment booking</li>
            <li>Visa interview preparation</li>
            <li>Financial and academic document verification</li>
          </ul>

          <h3>8. Scholarship and Financial Aid Guidance</h3>
          <p>
            We help you explore <i>scholarships, tuition discounts, and financial aid opportunities</i> across institutions.
          </p>

          <h3>9. Pre-Departure Support</h3>
          <p>Before you travel, we guide you on:</p>

          <ul>
            <li>Travel arrangements</li>
            <li>Accommodation options</li>
            <li>Cost of living abroad</li>
            <li>Cultural and academic preparation</li>
          </ul>

          
          <h2>Why Choose Our Agency?</h2>

          <ul>
            <li>Expert guidance for international education pathways</li>
            <li>Strong experience in student visa applications</li>
            <li>High success rate in admissions and approvals</li>
            <li>Personalized support from start to finish</li>
            <li>Trusted global institution partnerships</li>
            <li>Transparent and reliable service</li>
          </ul>

          <p>
            We are dedicated to helping students achieve their academic dreams with <i>confidence, clarity, and success</i>.
          </p>

          
          <h2>Popular Study Destinations We Cover</h2>

          <ul>
            <li>Canada</li>
            <li>United Kingdom</li>
            <li>United States</li>
            <li>Australia</li>
            <li>Germany</li>
            <li>Ireland</li>
            <li>Netherlands</li>
            <li>Turkey</li>
            <li>Malaysia and more</li>
          </ul>

          
          <h2>Begin Your Study Abroad Journey</h2>

          <p>
            Your future starts with the right education. Whether you are planning undergraduate or postgraduate studies,
            we are here to support you every step of the way.
          </p>

          <p>
            <b>Contact us today</b> and take the first step toward your international education journey!
          </p>

        </div>

      </section>

      <Footer />
      <WhatsAppFloat/>
    </div>
  );
}

export default Study;